export default {
    map: {},
    units: [],
    models: [],
    objects: [],
    customer: {},
    activePath: [],
    sessionId: null,
    isLoading: false,
    landscape: false,
    activeStep: null,
    myPosition: null,
    activeStepIndex: null,
    lastMoviesUpdate: null,
    appLoaded: false,
    mapLoading: true,
    playerUrl: null,
    terminalId: null,
    isEmbedForbidden: false,
    terminalCode: null,
    listsAndItems: [],
    activeLocale: 'en',
    defaultLocale: 'en',
    integrationId: null,
    dataSourceType: null,
    mapLoadingProgress: 0,
    activeMapTheme: ['default'],
    lastModified: null,
    canUpdateMapData: false,
    unfilteredMapObjects: null,
    isMapDataUpdateNeeded: false,
    lastModifiedCheckedAt: null,
    isMobileGuideStartActivate: false,
    isCompassOrientationMode: false,
    isArOrientationMode: false,
    isCompassEnabled: false,
    terminalsList: [],
    moviesListTimeout: null,
    moviesList: [],
    showsData: []
};
